import { css } from '@huspy/styled-system/css';

const casesTableStyles = {
  bankIcon: css({
    borderRadius: '50%',
    border: '2px solid #A5B4FC',
    backgroundColor: 'bg-primary',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  bankSmallIcon: css({
    minWidth: '24px',
    height: '24px',
    marginLeft: '-8px',
    borderRadius: '50%',
    backgroundColor: 'bg-primary',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  mortgageTypeBadge: css({
    paddingX: 3,
    paddingY: 0.5,
    borderRadius: 'radius-3',
    width: 'fit-content',
  }),
  tableContentText: css({
    fontSize: 'xl',
    fontWeight: 'regular',
    '@media (max-width: 1440px)': {
      fontSize: 'md',
      fontWeight: 'medium',
    },
  }),
  tableContentBankNameText: css({
    fontSize: 'xl',
    fontWeight: 'regular',
    display: 'block',
    '@media (max-width: 1440px)': { display: 'none' },
  }),
};

export default casesTableStyles;
